<template>
    <modal @close="cancel" dialog="modal-lg" class="dark-top heightAuto" :footer="false">
        <div slot="title">
            <h2 v-if="isNewAccount">Create Account</h2>
            <h2 v-else>Edit Account</h2>
        </div>

        <div slot="body" class="d-flex flex-column">
            <div class="form py-3 flexGrow1">
                <div class="col-sm-12">
                    <h5 class="w-100  d-flex justify-content-between">
                        <div>User Info</div>

                        <div v-if="accessPermissionFilter(['admin'])">
                            Active
                            <toggle-button class="ml-3" v-model="userAccount.isActive" :labels="{checked: 'Yes', unchecked: 'No'}" />
                        </div>
                    </h5>
                </div>

                <div class="form-group d-flex">
                    <div class="col-sm-3">
                        <avatar-uploader
                            :value="userAccount.imagePhotoBase64 || userAccount.imagePhoto"
                            :originalImage="originalUserAccount && (originalUserAccount.imagePhotoBase64 || originalUserAccount.imagePhoto)"
                            :placeholder="'agent'"
                            :showPreview="true"
                            :showButton="true"
                            :showRequirements="true"
                            :requirementsBelowImage="false"
                            :buttonType="'picture'"

                            :isSizeOk.sync="avatarRequirements.isSizeOk"
                            :isFormatOk.sync="avatarRequirements.isFormatOk"

                            :image.sync="userAccount.imagePhoto"
                            :imageBase64.sync="userAccount.imagePhotoBase64"
                            :imageHash.sync="userAccount.imagePhotoHash"

                            :originalImageSync.sync="originalUserAccount.imagePhoto"
                            :originalImageBase64Sync.sync="originalUserAccount.imagePhotoBase64"
                            :originalHashSync.sync="originalUserAccount.imagePhotoHash"
                        />
                    </div>

                    <div class="col-sm-9">
                        <div class="row">
                            <div class="col-sm-6">
                                <label class="full">
                                    Name
                                    <input type="text" v-model="userAccount.name" @input="$v.userAccount.name.$touch">
                                </label>

                                <div v-if="$v.userAccount.name.$error" class="fs-small color-6">
                                    <span v-if="!$v.userAccount.name.required">Name is required.</span>
                                    <span v-if="!$v.userAccount.name.minLength">Name must have at least 3 characters</span>
                                </div>
                            </div>

                            <div class="col-sm-6">
                                <label class="full">
                                    Email
                                    <input type="text" v-model.trim="userAccount.email" @input="$v.userAccount.email.$touch" :disabled="!isNewAccount">
                                </label>

                                <div v-if="$v.userAccount.email.$error" class="fs-small color-6">
                                    <span v-if="!$v.userAccount.email.required">Email is required.</span>
                                    <span v-if="!$v.userAccount.email.email">Must be a valid email.</span>
                                    <span v-if="!$v.userAccount.email.isUnique">This email is already in use.</span>
                                </div>
                            </div>

                            <div class="col-sm-6 mt-3" v-if="selectedAccesType && accessPermissionFilter(['admin'])">
                                <label class="full">
                                    Access type
                                </label>

                                <v-select
                                    :options="getUserAccessTypes"
                                    v-model="selectedAccesType"
                                    @input="accessTypeChanged"
                                    :disabled="isEditingOwnAdminAccessType"
                                ></v-select>
                            </div>

                            <div class="col-sm-6 mt-3" v-if="getSalesChannels && accessPermissionFilter(['admin'])">
                                <label class="full">
                                    Sales Channel
                                </label>

                                <div v-if="userAccount.salesChannel">
                                    <v-select :options="possibleSalesChannels" v-model="userAccount.salesChannel" label="name"></v-select>
                                </div>
                                <div v-else>
                                    <button class="btn tertiary" @click="setSalesChannel">Set Sales Channel</button>
                                </div>
                            </div>

                            <div class="col-sm-6 mt-3">
                                <label class="full">
                                    Default Homepage (after login)
                                </label>

                                <v-select :options="homePagesOptions" v-model="homePage" label="name" @input="homePageChanged($event)"></v-select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group d-flex" v-if="false">
                    <div class="col-sm-6">
                        <label class="full">
                            Name
                            <input type="text" v-model="userAccount.name" @input="$v.userAccount.name.$touch">
                        </label>

                        <div v-if="$v.userAccount.name.$error" class="fs-small color-6">
                            <span v-if="!$v.userAccount.name.required">Name is required.</span>
                            <span v-if="!$v.userAccount.name.minLength">Name must have at least 3 characters</span>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <label class="full">
                            Email
                            <input type="text" v-model.trim.lazy="userAccount.email" @blur="$v.userAccount.email.$touch" :disabled="!isNewAccount">
                        </label>

                        <div v-if="$v.userAccount.email.$error" class="fs-small color-6">
                            <span v-if="!$v.userAccount.email.required">Email is required.</span>
                            <span v-if="!$v.userAccount.email.email">Must be a valid email.</span>
                            <span v-if="!$v.userAccount.email.isUnique">This email is already in use.</span>
                        </div>
                    </div>
                </div>

                <div class="form-group d-flex" v-if="false">
                    <div class="col-sm-6" v-if="selectedAccesType">
                        <label class="full">
                            Access type
                        </label>
                        <v-select :options="getUserAccessTypes" v-model="selectedAccesType" @input="accessTypeChanged"></v-select>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-between align-items-center mb-4 p-3">
                <div>
                    <button
                        v-if="accessPermissionFilter(['admin']) && userAccount && userAccount.id !== account.id"
                        class="btn action wider"
                        @click="deleteAccount"
                    >
                        <i class="ico ico-delete"></i> Delete Account
                    </button>
                </div>

                <div>
                    <button class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                    <button class="btn green wider" @click="save" :disabled="loading || isFormInvalid || validateSupplier" :class="{'opacity-50': isFormInvalid || validateSupplier}"> {{loading ? 'Saving...' : 'Save'}}</button>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import { required, email, minLength } from 'vuelidate/lib/validators'

    import extendedVSelect from '@/extends/vue-select'
    import Modal from './Modal'
    import AvatarUploader from '@/components/common/AvatarUploader.vue'
    
    export default {
        data() {
            return {
                loading: false,
                userAccount: null,
                originalUserAccount: null,
                selectedAccesType: null,
                homePagesOptions: [
                    { id: 0, name: 'Home' },
                    { id: 1, name: 'Calendar' },
                    { id: 2, name: 'Reservations' }
                ],
                homePage: { id: 0, name: 'Home' },
                avatarRequirements: {
                    isSizeOk: true,
                    isFormatOk: true
                }
            }
        },
        created() {
            if (this.isNewAccount) {
                this.setUserAccountVirgin();
            } else {
                // Initialize from selected account right away (replaces the watcher)
                const sel = this.getSelectedSupplierAccount;
                
                if (sel) {
                    this.userAccount = { ...sel };
                    this.originalUserAccount = JSON.parse(JSON.stringify(this.userAccount));
                }
            }

            // Guarded initialization of selectedAccesType
            if (this.userAccount && this.userAccount.userAccountTypeDefault) {
                this.setSelectedAccessType(this.userAccount.userAccountTypeDefault);
            } else {
                // Fallback to a sensible default if needed
                this.setSelectedAccessType(null);
            }
        },
        validations: {
            userAccount: {
                email: {
                    required,
                    email,
                    isUnique() {
                        return this.isUniqueEmail() || true;
                    }
                },
                name: {
                    required,
                    minLength: minLength(3)
                }
            }
        },
        mounted() {
            const id =
                this.userAccount &&
                this.userAccount.userAccountTypes &&
                this.userAccount.userAccountTypes[0] &&
                this.userAccount.userAccountTypes[0].defaultHomePage;

            const fallbackId = 0;
            this.homePage =
                this.homePagesOptions.find(hp => hp.id == (id != null ? id : fallbackId)) ||
                this.homePagesOptions[0];
        },
        computed: {
            ...mapGetters([
                'getUserAccessTypes',
                'getSupplierAccountVirgin',
                'getSelectedSupplierAccount',
                'account',
                'getSalesChannels',
                'getUserDetails',
            ]),
            validateSupplier() {
                return JSON.stringify(this.originalUserAccount) === JSON.stringify(this.userAccount);
            },
            possibleSalesChannels() {
                let allowedSalesChannelTypes = new Array(0, 9999);

                return this.getSalesChannels
                    .filter(salesChannel => allowedSalesChannelTypes.includes(salesChannel.channelType))
                    .map(salesChannel => {
                        let { ticketType_helper_selected, ...rest } = salesChannel;
                        
                        return rest;
                    });
            },
            isNewAccount() {
                return this.getSelectedSupplierAccount == null;
            },
            isFormInvalid() {
                return this.$v.userAccount.$invalid;
            },
            isEditingOwnAdminAccessType() {
                return (
                    this.userAccount &&
                    this.account &&
                    this.userAccount.id === this.account.id &&
                    this.selectedAccesType &&
                    this.selectedAccesType.code === 'admin'
                )
            },
        },
        methods: {
            ...mapActions([
                'closeModal',
                'createSupplierAccount',
                'editSupplierAccount',
                'setStatusSupplierAccount',
                'deleteSupplierAccount',
                'refreshAccountData',
                'setSupplierAccountAsSelected',
                'downloadSupplierAccounts'
            ]),
            homePageChanged(event) {
                this.$set(this.userAccount.userAccountTypes[0], 'defaultHomePage', event.id);
            },
            setUserAccountVirgin() {
                this.$set(this, 'userAccount', JSON.parse(JSON.stringify(this.getSupplierAccountVirgin)));

                this.originalUserAccount = JSON.parse(JSON.stringify(this.userAccount));
            },
            setUserAccountStored() {
                this.$set(this, 'userAccount', this.getSelectedSupplierAccount);
                this.originalUserAccount = JSON.parse(JSON.stringify(this.userAccount));
            },
            createNewAccount() {
                this.loading = true;

                this.createSupplierAccount(this.userAccount).then(r => {
                    this.loading = false
                    if (r) {
                        this.downloadSupplierAccounts().then(() => {
                            this.setUserAccountStored(); // <-- Refresh local userAccount with latest from store
                            this.closeModal();
                        });
                    } else {
                        this.$toasted.error('Error creating account, check everything and try again.');
                    }
                }).catch(error => {
                    this.loading = false;
                })
            },
            updateAccount() {
                this.loading = true;

                this.editSupplierAccount(this.userAccount).then(response => {
                    this.loading = false;
                    if (response.status === 200) {
                        // If editing own account, refresh global user details (navbar, etc)
                        if (response.data.id === this.account.id) {
                            this.refreshAccountData();
                        }

                        // Download all supplier accounts and update the selected one
                        this.downloadSupplierAccounts().then(() => {
                            // Set the just-updated account as selected in the store
                            this.setSupplierAccountAsSelected(response.data);

                            // Update the modal's local userAccount from the store
                            this.setUserAccountStored();

                            // Close the modal
                            this.closeModal();
                        });
                    } else {
                        this.$toasted.error('Error editing account, check everything and try again.');
                    }
                }).catch(error => {
                    this.loading = false;
                    this.$toasted.error('Error editing account, check everything and try again.');
                });
            },
            changeStatusAccount(action) {
                this.setStatusSupplierAccount({
                    userAccount: this.userAccount,
                    action: action,
                }).then(r => {
                    if (r) {
                    } else {
                        this.$toasted.error('Error changing account status, check everything and try again.');
                    }
                })
            },
            deleteAccount() {
                let vm = this;
                
                this.$dialog.confirm('<b>Delete Account?</b><br>This action is irreversible!')
                .then(() => {
                    vm.deleteSupplierAccount(vm.userAccount).then( r => {
                        if(r){
                            vm.$toasted.info('Account deleted');
                            vm.closeModal()
                        }
                    })
                })
                .catch(() => {
                });
            },
            isUniqueEmail: _.debounce(function() {
                    let email = this.userAccount.email;

                    if (email != '') {
                        if (!this.isNewAccount) {
                            return true;
                        }
                        return axios.get(axios.authURL + 'auth/IsEmailFree', {
                                params: {
                                    email: email
                                }
                        }).then(response => {
                            if (response && response.status === 200) {
                                return response.data.isSuccessStatusCode;
                            }
                        }).catch(error => {
                            return false;
                        })
                    } else {
                        return false;
                    }
                },
                500
            ),
            accessTypeChanged(selectedAccesType) {
                if (selectedAccesType !== null) {
                    this.$set(this.userAccount.userAccountTypes[0], 'accessType', selectedAccesType.id);
                } else {
                    this.userAccount.userAccountTypes[0].accessType = this.getUserAccessTypes[1].id;
                    this.selectedAccesType = this.getUserAccessTypes[1];
                }
            },
            setSelectedAccessType(userAccountType) {
            // Handle null/undefined safely
            if (!userAccountType) {
                // default to id=2 (as your original fallback) or first available
                this.selectedAccesType =
                this.getUserAccessTypes.find(a => a.id == 2) || this.getUserAccessTypes[0];
                return;
            }

            this.selectedAccesType = this.getUserAccessTypes.find(
                accessType => accessType.id == userAccountType.accessType
            );

            if (!this.selectedAccesType) {
                this.selectedAccesType =
                this.getUserAccessTypes.find(a => a.id == 2) || this.getUserAccessTypes[0];
            }
            },
            setSalesChannel() {
                this.$set(this.userAccount, 'salesChannel', this.getSalesChannels[0]);
            },
            cancel() {
                this.closeModal();
            },
            save() {
                if (this.loading) {
                    return false;
                }
                
                // keep existing form-invalid toast behaviour
                if (this.isFormInvalid) {
                    this.$toasted.error('Check all fields and try again');
                    
                    return false;
                }
                const avatarInvalid = !this.avatarRequirements.isSizeOk || !this.avatarRequirements.isFormatOk;

                if (avatarInvalid) {
                    this.$dialog.alert(
                        '\
                            <div class="fs-larg font-weight-600 mb-4">Invalid configuration</div>\
                            <div>Please check the fields marked red, and try again.</div>',
                        { okText: "Ok" }
                    )
                    .then(() => {});
                    
                    return;
                }

                if (this.isNewAccount) {
                    this.createNewAccount();
                } else {
                    this.updateAccount();
                }
            },
        },
        components: {
            Modal,
            vSelect: extendedVSelect,
            AvatarUploader
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';
</style>



// WEBPACK FOOTER //
// supplierAccountModal.vue?3b3e0990